<div class="flex flex-wrap">
  @if (!legendBelowPlot()) {
    <div class="flex flex-col p-2 w-1/2">
      <p-fieldset legend="X Axis Options">
        <div class="flex flex-row gap-2">
          <div class="flex flex-col">
            <label>Min</label>
            @if (plotState()?.xAxisRange?.length === 2) {
              <p-inputnumber
                #xAxisMinRef
                [ngModel]="plotState()?.xAxisRange[0]"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="2"
                (onBlur)="onAxisBlur(xAxisMinRef, 'xAxis', 0)"
              />
            }
          </div>
          <div class="flex flex-col">
            <label>Max</label>
            @if (plotState()?.xAxisRange?.length === 2) {
              <p-inputnumber
                #xAxisMaxRef
                [ngModel]="plotState()?.xAxisRange[1]"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="2"
                (onBlur)="onAxisBlur(xAxisMaxRef, 'xAxis', 1)"
              />
            }
          </div>
          <div class="flex flex-col">
            <label>Spacing</label>
            <p-inputnumber
              #xAxisTickRef
              [ngModel]="plotState()?.xAxisTick"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              (onBlur)="onTickBlur(xAxisTickRef, 'xAxis')"
            />
          </div>
        </div>
      </p-fieldset>
    </div>
  }

  <div class="flex flex-col p-2 w-1/2">
    <div class="flex flex-row gap-2 items-center">
      <div class="flex flex-col">
        <p-fieldset legend="Y Axis Options">
          <div class="flex flex-row gap-2">
            @if (plotState()?.yAxisRange) {
              <div class="flex flex-col">
                <label>Min</label>
                @if (plotState()?.yAxisRange?.length === 2) {
                  <p-inputnumber
                    #yAxisMinRef
                    [ngModel]="plotState()?.yAxisRange[yMinIndex()]"
                    mode="decimal"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    (onBlur)="onAxisBlur(yAxisMinRef, 'yAxis', yMinIndex())"
                  ></p-inputnumber>
                }
              </div>
            }
            <div class="flex flex-col">
              <label>Max</label>
              @if (plotState()?.yAxisRange?.length === 2) {
                <p-inputnumber
                  #yAxisMaxRef
                  [ngModel]="plotState()?.yAxisRange[yMaxIndex()]"
                  mode="decimal"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  (onBlur)="onAxisBlur(yAxisMaxRef, 'yAxis', yMaxIndex())"
                ></p-inputnumber>
              }
            </div>
            <div class="flex flex-col">
              <label>Spacing</label>
              <p-inputnumber
                #yAxisTickRef
                [ngModel]="plotState()?.yAxisTick"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="2"
                (onBlur)="onTickBlur(yAxisTickRef, 'yAxis')"
              />
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="flex flex-row gap-2">
        <p-button
          outlined="true"
          class="pl-2 outlined-button"
          size="small"
          severity="success"
          label="Reset"
          (click)="reset.emit()"
          icon="pi pi-refresh"
        >
        </p-button>
      </div>
    </div>
  </div>
</div>
